import clsx from 'clsx';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Axios from '@/src/axiosPool';
import CancelUpload from '@/src/components/common/Upload/CancelUpload';
import { showToast } from '@/src/globalFunction';
import { RootState } from '@/src/reducers/types';

import ArchivedConfirmation from '../../../Conversations/Modal/ArchivedConfirmation/ArchivedConfirmation';
import ConversationInfo from '../../../Conversations/Modal/ConversationInfo/ConversationInfo';
import CreateConversation from '../../../Conversations/Modal/CreateConversation/CreateConversation';
import ViewConversation from '../../../Conversations/Modal/ViewConversation/ViewConversation';

const Conversations = ({ projectId }) => {
  const conversations = useSelector((store: RootState) => store.conversations);
  const dispatch = useDispatch();

  function handleArchived() {
    const selected = conversations.selected;
    const isArchived = selected.isArchived;
    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

    Axios.put(`/api/conversation/setArchived/${projectId}`, {
      isArchived: !isArchived,
      conversations: [selected.id],
    }).then((response) => {
      if (response) {
        showToast('success', `Conversation moved to ${isArchived ? 'Active' : 'Archived'}`);
        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
        dispatch({
          type: 'UPDATE_CONVERSATIONS_SELECTED',
          selected: { ...conversations.selected, isArchived: !isArchived },
        });
        $('#archivedConfirmation').modal('hide');
      } else {
        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
      }
    });
  }

  function handleUploadCancel() {
    const index = conversations.uploadActiveIndex;
    if (index > -1) {
      $('#conversation-cancel').trigger('click');
    } else {
      dispatch({ type: 'SET_NOTES_SELECTED', Selected: {} });
      dispatch({ type: 'UPDATE_CONVERSATIONS_SELECTED', selected: {} });
      dispatch({ type: 'CONVERSATION_UPLOADED_STATUS', bool: true });
      dispatch({ type: 'UPDATE_CONVERSATIONS_FIELD', field: 'message', value: {} });
      dispatch({ type: 'CONVERSATION_FILE_INSERTED', bool: false });
    }
    $('#upload-cancel').modal('hide');
  }

  return (
    <React.Fragment>
      <CreateConversation projectId={projectId} />
      <ViewConversation
        handleArchived={handleArchived}
        scrollClassName={clsx(
          conversations.inserted ? '!tw-max-h-[calc(100vh-565px)]' : '!tw-max-h-[calc(100vh-430px)]'
        )}
      />
      <ArchivedConfirmation archive={handleArchived} id={'archivedConfirmation'} />
      <CancelUpload onCancel={handleUploadCancel} />
      {conversations.showInfoModal && <ConversationInfo />}
    </React.Fragment>
  );
};

export default Conversations;
